// Brand UI font (Google Fonts via FontUtil.applyBrandFont).
// Agency/project overrides still use FontUtil.setFont.
export const brandFont = 'Sora';

export const entityMenuMaxWidth = 600;
export const entityMenuMinWidth = 220;
export const entitySearchMinCount = 5;

export const chatgptPluginUrl = 'https://chatgpt.com/plugins/plugin_asdk_app_6a3699f00ba88191843d86aef525f03e';
export const claudeColor = '#d97757';
export const claudeInstallUrl = 'https://claude.ai/directory/more-good-reviews';
export const demoUrl = 'https://cal.com/moregoodreviews/demo';
export const docsUrl = 'https://docs.moregoodreviews.com';
export const feedbackUrl = 'https://feedback.moregoodreviews.com';

export const landingWidgetUuids = {
    badge: 'a4d01e42-f8d8-439b-8215-8bc97d88c5de',
    carousel: '50d86f78-4577-4e01-8447-09cca4d4ab57',
    wall: '762158a8-d09c-4cbd-9023-8f14f4eed022',
};

export const languages = {
    'en': 'English',
    'de': 'Deutsch',
    'es': 'Español',
    'fi': 'Suomi',
    'fr': 'Français',
    'it': 'Italiano',
    'ja': '日本語',
    'nb-NO': 'Norsk bokmål',
    'nn-NO': 'Norsk nynorsk',
    'nl': 'Nederlands',
    'pl': 'Polski',
    'pt-BR': 'Português (Brasil)',
    'pt-PT': 'Português (Portugal)',
    'sr': 'Srpski',
    'sv': 'Svenska',
    'tr': 'Türkçe',
    'uk': 'Українська',
};
